import * as clipboard from 'clipboard-polyfill'
import {logger} from 'yougile-util'
import {showAlert, showPrompt} from '@components/common/base/notifications'
import {Backend} from '../../common/backend'
import {MessageBox} from '../components/message-box'
import {globals} from './globals-base'

export class KeyboardShortcuts {
  private static initializedAlready = false

  private static async makeReadonly(): Promise<void> {
    const readonly = !!+(
      (await showPrompt(
        'Input “1” to make account readonly and “0” to enable changes for this account'
      )) || 0
    )
    const key = await showPrompt('Enter key')
    Backend.postJSON('/data/account/readonly', {
      key,
      userId: globals.currentUserId,
      readonly
    })
      .then(() => {
        void showAlert('Done')

        location.reload()
      })
      .catch((): undefined => {
        void showAlert('Failed')
        return undefined
      })
  }

  private static copyCompanyId(): void {
    const companyId = globals.getCompanyId()
    clipboard
      .writeText(companyId)
      .then(() => MessageBox.show(`Company id ${companyId}`, 'success'))
      .catch(err => logger.log('err', err))
  }

  static init(): void {
    if (this.initializedAlready) {
      return
    }
    this.initializedAlready = true

    document.addEventListener('keyup', e => {
      if (!e.ctrlKey || !e.altKey) {
        return
      }
      if (e.code === 'KeyJ') {
        void this.makeReadonly()
      }

      if (e.code === 'KeyQ') {
        this.copyCompanyId()
      }
    })
  }
}
